import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
 import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,
  OnEventArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, year } from '../../../models/slakpi';
import { division } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';
@Component({
  selector: 'app-bench-mark-inbox',
  templateUrl: './bench-mark-inbox.component.html',
  styleUrls: ['./bench-mark-inbox.component.css']
})
export class BenchMarkInboxComponent implements OnInit {
  
  
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public division_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('viewtemplate', { static: false }) viewtemplate: TemplateRef<any>;
  @ViewChild('sendapprovaltemplate', { static: false }) sendapprovaltemplate: TemplateRef<any>;
  @ViewChild('approvetemplate', { static: false }) approvetemplate: TemplateRef<any>;
  @ViewChild('rejecttemplate', { static: false }) rejecttemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  angularGrid: AngularGridInstance;
  public TranKPI_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isStart: boolean = true;
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;

  public filterAll_classactive: string = '';
  public filterDataCollection_classactive: string = 'active';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = '';
  public filterApproval_classactive: string = '';
  public tranBenchMarkKPIHistory_data: any;

  objTranBenchmarkKPI: any = new tranbenchmarkkpi();
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
  statusUno: number = 1;
    searchText: string;
  dataSearch: any[];

  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
    yearData: any;
  constructor(public restApiBM: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public restSLAKPIApi: SLAKPIApiService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("KPI Inbox");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.yearfilter= Number(this.user.currentYear);
    this.halffilter = Number(this.user.currentHalf);
    this.login_UserID = this.user.id;
    

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    this.loadYear();
    //this.getBenchMarkYear();
    this.getDivisions();
    this.getcurrentHalf();
    this.LoadTranBenchmarkKPI();
    this.loadBenckMarkKPIInboxCount();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  getBenchMarkYear() {
    
    let date = new Date();
    let pastYear = date.getFullYear() - 1;
    let currentYear = date.getFullYear();
    let futureYear = date.getFullYear() + 1;

    this.benchMarkYear_data = [
      { text: pastYear, value: pastYear },
      { text: currentYear, value: currentYear },
      { text: futureYear, value: futureYear }
    ];
  }
  getcurrentHalf() {
    

    this.currentHalf_data = [
      { text: 'First Half', value: 1 },
      { text: 'Second Half', value: 2 }
    ];
  }

  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApiBM.getDivisions(inpValue)
      .subscribe(data => {
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  searchKPIRelease() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () {
        temp.loadBenckMarkKPIInboxCount();
        temp.LoadTranBenchmarkKPI();
      }, 1000)

    }

  }



  LoadTranBenchmarkKPI() {
    
    let currentYear = new Date().getFullYear();
    this.yearfilter = this.yearfilter ? this.yearfilter : currentYear;
    this.halffilter = this.halffilter ? this.halffilter : 1;

    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = (this.statusUno==2)?2:1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.statusUno = this.statusUno;
    inpValue.benchmarkYear = this.yearfilter;
    inpValue.divisionUno = (this.divisionUnofilter > 0) ? this.divisionUnofilter : 0;
    inpValue.kpiType = (this.halffilter ==1)?2:4;
    this.restApiBM.getTranBenchMarkKPIs(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        const mockDataset = [];
        this.dataset = [];
        if (rtn_data != null && rtn_data.length > 0) {

           //uniqBy(data, 'kpiUno');
          
          for (let i = 0; i < rtn_data.length; i++) {

            let status = '';
            if (rtn_data[i].statusUno == '0')
              status = 'Released';
            else if (rtn_data[i].statusUno == '1')
              status = 'Data Entry';
            else if (rtn_data[i].statusUno == '2')
              status = 'Approval 1';
            else if (rtn_data[i].statusUno == '3')
              status = 'Approval 2';
            else if (rtn_data[i].statusUno == '4')
              status = 'Approval 3';
            else if (rtn_data[i].statusUno == '5')
              status = 'Completed';

           

            mockDataset[i] = {
              id: rtn_data[i].trnBenchmarkUno,
              kpiCode: rtn_data[i].kpiCode,
              kpiNameEn: rtn_data[i].kpiNameEn,
              dataOwnerName: rtn_data[i].dataOwnerName,
              dataOwnerUno: rtn_data[i].dataOwnerUno,
              level1ApproverUno: rtn_data[i].level1ApproverUno,
              level2ApproverUno: rtn_data[i].level2ApproverUno,
              level3ApproverUno: rtn_data[i].level3ApproverUno,
              targetValue: rtn_data[i].targetValue,
              actualValue: (rtn_data[i].actualValue == '') ? '-' : rtn_data[i].actualValue,
              kpiRule: rtn_data[i].kpiRule,
              rowType: rtn_data[i].rowType,
              isRelease: rtn_data[i].isRelease,
              statusUno: rtn_data[i].statusUno,
              formula: rtn_data[i].formula,
              status: status
            };
          }
          this.dataset = mockDataset;
          this.dataSearch = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          this.TranKPI_data = rtn_data;
         
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
          this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  loadBenckMarkKPIInboxCount() {
    let currentYear = new Date().getFullYear();
    this.yearfilter = this.yearfilter ? this.yearfilter : currentYear;
    this.halffilter = this.halffilter ? this.halffilter : 1;

    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.divisionUno = (this.divisionUnofilter > 0) ? this.divisionUnofilter : 0;
    inpValue.benchmarkYear = this.yearfilter;
    inpValue.kpiType = (this.halffilter == 1) ? 2 : 4;//this.halffilter ? this.halffilter : 1;    
    inpValue.isAdmin = this.isAdmin;

    this.restApiBM.getBenchmarkKpiInboxCount(inpValue)
      .subscribe(data => {

        //this.kpiInbox_data_count = data[0];
        this.filterDataCollectionCount = data[0].filterDataCollectionCount;
        this.filterCompletedCount = data[0].filterCompletedCount;
        this.filterApprovalCount = data[0].filterApprovalCount;
        

      },
        (error) => {
          //Called when error
          //this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiNameEn && a.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.dataOwnerName && a.dataOwnerName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetValue && a.targetValue.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.status && a.status.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'dataOwnerName', name: 'Owner', field: 'dataOwnerName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'dataOwnerName', 'dataOwnerName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'actualValue', name: 'Actual', field: 'actualValue', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actualValue', 'actualValue'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValue', name: 'Target', field: 'targetValue', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'formula', name: 'KPI Rule', field: 'formula', sortable: true, cssClass: 'text-hidden', toolTip: 'formula', 
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'formula', 'formula'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'rowType', name: 'Row Type', field: 'rowType', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'rowType', 'rowType'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'status', name: 'Status', field: 'status', sortable: true,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.status == 'Data Entry')
            return '<span  class="status-area status-red">Data Entry</span>';
          else if (data.status == 'Approval 1')
            return '<span  class="status-area status-orange">Approval 1</span>';
          else if (data.status == 'Approval 2')
            return '<span  class="status-area status-yellow">Approval 2</span>';
          else if (data.status == 'Approval 3')
            return '<span  class="status-area status-light-green">Approval 3</span>';
          else if (data.status == 'Completed')
            return '<span  class="status-area status-green">Completed</span>';
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
        type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span style="cursor:pointer"><i class="fa fa-pencil-square-o fa-lg"></i></span>'; },
        onCellClick: (e: Event, args: OnEventArgs) => {
          this.pageAction = 'view';
          let rdata: any = args.dataContext;
          //this.getViewHistory(rdata.id);



          this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
          return false;
        }
      }
      
      //,{
      //  id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
      //  excludeFromExport: true,
      //  formatter: this.actionFormatter,
      //  cellMenu: {
      //    hideCloseButton: false,
      //    commandTitleKey: 'COMMANDS',
      //    commandItems: [

      //      {
      //        command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'View Detail',
      //        itemVisibilityOverride: (args: MenuCallbackArgs) => {
      //          let data = args.dataContext;

      //          if (this.isBMChampion || this.isBMVisitor)
      //            return false;
      //          else return true;
      //        },
      //        iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
      //        action: (e, args) => {
      //          this.pageAction = 'view';
      //          let rdata: any = args.dataContext;
      //          //this.getViewHistory(rdata.id);

                
                  
      //            this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
      //            return false;
               
      //          //this.modalRef = this.modalService.show(
      //          //  this.viewtemplate,
      //          //  Object.assign({}, { class: 'gray modal-lg' })
      //          //);

      //        },
      //      //  // only show command to 'Delete Row' when the task is not completed

      //     },
      //      { divider: true, command: '', positionOrder: 63 },

      //      //{
      //      //  command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'View History',
      //      //  iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
      //      //  action: (e, args) => {
      //      //    this.pageAction = 'view';
      //      //    let rdata: any = args.dataContext;
      //      //    this.getViewHistory(rdata.id);

      //      //    this.modalRef = this.modalService.show(
      //      //      this.viewtemplate,
      //      //      Object.assign({}, { class: 'gray modal-lg' })
      //      //    );
                
      //      //  },
      //      //  // only show command to 'Delete Row' when the task is not completed

      //      //},
      //      //{ divider: true, command: '', positionOrder: 63 },

           
            
      //      //{
      //      //  command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Send for Approval',
      //      //  iconCssClass: 'fa fa-send-o fa-lg', cssClass: 'blue', textCssClass: 'bold',
      //      //  action: (e, args) => {
      //      //    this.pageAction = 'send';
      //      //    let rdata: any = args.dataContext;

      //      //    
      //      //    this.objTranBenchmarkKPI = new tranbenchmarkkpi;
      //      //    this.objTranBenchmarkKPI.trnBenchmarkUno = rdata.id;
      //      //    this.objTranBenchmarkKPI.statusUno = rdata.statusUno;
      //      //    this.objTranBenchmarkKPI.targetValue = rdata.targetValue;
      //      //    this.objTranBenchmarkKPI.actualValue = rdata.actualValue;

      //      //    this.modalRef = this.modalService.show(
      //      //      this.sendapprovaltemplate,
      //      //      Object.assign({}, { class: 'gray modal-lg' })
      //      //    );
      //      //  },
      //      //  // only show command to 'Delete Row' when the task is not completed

      //      //},
      //      //{ divider: true, command: '', positionOrder: 65 },
      //      //{
      //      //  command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 66, title: 'Approval',
      //      //  iconCssClass: 'fa fa-check-circle fa-lg', cssClass: 'blue', textCssClass: 'bold',
      //      //  action: (e, args) => {
      //      //    this.pageAction = 'approve';
      //      //    let rdata: any = args.dataContext;
      //      //    this.objTranBenchmarkKPI = new tranbenchmarkkpi;
      //      //    this.objTranBenchmarkKPI.trnBenchmarkUno = rdata.id;
      //      //    this.objTranBenchmarkKPI.statusUno = rdata.statusUno;
                
      //      //    this.modalRef = this.modalService.show(
      //      //      this.approvetemplate,
      //      //      Object.assign({}, { class: 'gray modal-lg' })
      //      //    );
      //      //  },
      //      //  // only show command to 'Delete Row' when the task is not completed

      //      //},
      //      //{ divider: true, command: '', positionOrder: 67 },



      //      //{
      //      //  command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 68, title: 'Reject',
      //      //  iconCssClass: 'fa fa-ban fa-lg', cssClass: 'blue', textCssClass: 'bold',
      //      //  action: (e, args) => {
      //      //    this.pageAction = 'reject';
      //      //    let rdata: any = args.dataContext;
      //      //    this.objTranBenchmarkKPI = new tranbenchmarkkpi;
      //      //    this.objTranBenchmarkKPI.trnBenchmarkUno = rdata.id;
      //      //    this.objTranBenchmarkKPI.statusUno = rdata.statusUno;

      //      //    this.modalRef = this.modalService.show(
      //      //      this.rejecttemplate,
      //      //      Object.assign({}, { class: 'gray modal-lg' })
      //      //    );
      //      //  },
      //      //  // only show command to 'Delete Row' when the task is not completed

      //      //},

      //    ],
      //  }
      //}




    ]


  }
  onDbClicked(ev, es) {
    
  
    let rdata = this.angularGrid.gridService.getDataItemByRowIndex(es.row)


    if (rdata != null && rdata != undefined) {
      if (this.isBMChampion || this.isBMVisitor)
        return false;
      else {
        this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
      }
    }
    return false;
  }


  getViewHistory(id: number) {
    

    let inpValue = new tranbenchmarkkpihistory();

    inpValue.itemUno = id;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    this.restApiBM.getTranBenchMarkKPIHistory(inpValue)
      .subscribe(data => {
        
        this.tranBenchMarkKPIHistory_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }

  onSendApproval(val1, type) {
    
    if (!val1) {
     // Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter the required information.');
      return;
    }
    else {
      this.ApproveProcessBenchMarkEntry(this.objTranBenchmarkKPI, type)
    }
  }

  onfilterData(type: any) {
    if (type == 'data')
      this.statusUno = 1;
    if (type == 'approval')
      this.statusUno = 2;
    if (type == 'completed')
      this.statusUno = 5;

    this.filterDataCollection_classactive = (type == 'data') ? 'active' : '';
    this.filterApproval_classactive = (type == 'approval') ? 'active' : '';
    this.filterCompleted_classactive = (type == 'completed') ? 'active' : '';
   

    this.LoadTranBenchmarkKPI();
  }

  onApproveBenchMarkEntry(val1, type) {
    
    if (!val1) {
     // Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter the required information.');
      return
    }
    else {
      this.ApproveProcessBenchMarkEntry(this.objTranBenchmarkKPI, type)
    }
  }
  ApproveProcessBenchMarkEntry(data1: any, type: any) {
    
    let message = ''
    this.objTranBenchmarkKPI.userUno = 1;
    if (type == 'save') {
      this.objTranBenchmarkKPI.condition = 0;
      message = 'Data entry saved.';
    }      
    else if (type == 'send') {
      this.objTranBenchmarkKPI.condition = 1;
      message = 'Sent for approval.';
    }
    else if (type == 'approve') {
      this.objTranBenchmarkKPI.condition = 2;
      message = 'Approved successfully.';
    }
    else if (type == 'reject') {
      this.objTranBenchmarkKPI.condition = 3;
      message = 'Rejected successfully.';
    }
    
    this.objTranBenchmarkKPI.userUno = this.login_UserID;
    this.restApiBM.addEditTranBenchMarkKPI_Inbox(this.objTranBenchmarkKPI)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: message,
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', message);
          this.modalRef.hide();
          setTimeout(() => {
            this.spinner.hide();
            this.LoadTranBenchmarkKPI();
          }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;
  
  }
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
}
